///
/// EarthBrowser
///
/// Created by Matt Giger on 10/28/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Depth bias for overlays draped a fixed height above the terrain (storm
/// cones, tracks, wind swaths). A kilometre or two of lift is plenty up
/// close, but the depth buffer's resolvable step grows with the square of
/// the distance: from 5-8000 km out it is 0.15-0.4 km, and a draped fill's
/// triangle sag eats another half kilometre, leaving a couple of depth units
/// of headroom that varies by GPU and shows up as speckled fills and dashed
/// lines. gl.polygonOffset works in those resolvable units, so this pulls
/// the overlay toward the camera by a margin that tracks the precision at
/// its distance instead of lifting it further off the ground.
///

/** [factor, units] for DrawState.polygonOffset: slope-scaled plus four resolvable steps toward the camera */
export const cSurfaceOverlayDepthBias: [number, number] = [-1, -4]
